/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import BottomMenu from "./BottomMenu";
import {
  Grid,
  Box,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Slide,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useState, forwardRef, useEffect } from "react";
import { Badge } from "@mui/material";
import moment from "moment";
import PickersDay from "@mui/lab/PickersDay";
import DateFnsUtils from "@date-io/date-fns";
import { ko } from "date-fns/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styled from "styled-components";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import Login from "./Login";
import { useRecoilValue } from "recoil";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import BottomButton from "./BottomButton";
import { buttonClasses } from '@mui/material';
import axios from 'axios';
import 'moment/locale/ko';
import get_token from "../lib/get_token";
import get_fcid from '../lib/get_fcid';
import CouponSelect from './CouponSelect';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          maxHeight: "328px",
          height: "100%",
        }
      }
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          zIndex: 2
        }
      }
    },
  }
})

const inputTheme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: '-13.5px',
          fontSize: '14px'
        },
        shrink: {
          // top: '-6px'
          display: 'none'
        },
        nativeInput: {
          fontSize: '14px'
        }
      }
    }
  }
})
function Book() {
  const [openCoupon, setOpenCoupon] = useState(false);
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-DD")); // 선택날짜
  const [tcid, setTcid] = useState('');
  //강좌리스트
  const [lectures, setLectures] = useState(
    [
      // {
      //   id: 0,
      //   title: 'A',
      //   name: 'Smith',
      //   time: '오전 9:00',
      //   day: moment('20220306').format('YYYY-MM-DD'),
      //   applicate: '가능',
      //   // applicant: 8,
      //   // limit: 20,
      // },
      // {
      //   id: 1,
      //   title: 'B',
      //   name: 'Carrie',
      //   time: '오후 1:30',
      //   day: moment('20220306').format('YYYY-MM-DD'),
      //   applicate: '불가',
      //   // applicant: 12,
      //   // limit: 15,
      // },
    ]
  )

  //로그인 세션
  const [loaded, setLoaded] = useState(false);
  const [login, setLogin] = useState(loginState);
  const token = get_token();
  const [fcid, setFcid] = useState('');

  // 로그인
  // const login = useRecoilValue(loginState);
  // const config = useRecoilValue(configState);

  const [date, setDate] = useState(moment());
  const [highlightedDays, setHighlightedDays] = useState([1, 2, 15, 26]);

  const history = useHistory();

  const [openLogin, setOpenLogin] = useState(false);
  const clickOpenLogin = () => {
    setOpenLogin(true);
  };

  const clickCloseLogin = () => {
    setOpenLogin(false);
    setOpenAlert(false); // 알럿창 닫기
  };

  // const clickOpenCoupon = (params) => {
  //   const { tcd, hour, classname, tname, classmemo } = params;
  //   setOpenCoupon(true);
    
  // }

  const clickOpenCoupon = () => {
    setOpenCoupon(true);
  }

  const [openAlert, setOpenAlert] = useState(false);

  const minDate = new Date(moment().add(-1, 'years'));
  const maxDate = new Date(moment().add(+1, 'years'));

  //오늘날짜와 같거나 이전인 날짜들을 선택 못하게
  // const disableDate = (date) => {
  //     return date <= (new Date())
  // }

  //로그인 세션
  const get_session = async () => {
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/gympass/get_session", { token: token, cid: cid });
    if (result.data.mcd !== '' && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  }

  useEffect(() => {
    get_session();
  }, []);

  useEffect(() => {
    load_data();
    // setTcid(localStorage.getItem('fcid'))
  }, [tcid]);

  const handleDate = (newDate) => {
    setLectures([
      {
        id: 0,
        title: 'XZZ',
        name: 'Smith',
        time: '오전 9:00',
        day: moment('20220306').format('YYYY-MM-DD'),
        applicate: '예약',
        // applicant: 8,
        // limit: 20,
      }]);
  }

  // 날짜 변경시 수업리스트 새로 가져옴
  const onChangeDate = (newDate) => {
    setSdate(moment(newDate).format("YYYY-MM-DD"));
  }

  // 예약 가져오기
  const load_data = async () => {
    // pr('load_data');
    // pr('token = '+token);
    // pr('mcd = '+login.mcd);
    // pr('level = '+login.level);
    // pr('cid = ' + configState.cid);
    let result = await axios.post(configState.api + "/gympass/reservation_class", {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: configState.cid,
      sdate: sdate,
      tcid: fcid
    });

    if (result.data.success === 1) {
      setLectures(result.data.rows);
    }
    else {
      Swal.fire(result.data.msg);
    }

  }
  useEffect(() => {
    if (loaded) {
      // pr('loaded:'+loaded);
      // pr('sdate:'+sdate);
      load_data();
      let fcid_temp = get_fcid();
      if (fcid_temp !== null && fcid_temp !== '') {
        setFcid(fcid_temp);
        // load_data();
      };
    }
  }, [loaded, sdate, login]);

  useEffect(() => {
    if (fcid !== undefined && fcid !== '') {
      localStorage.setItem('fcid', fcid);
      load_data();
    }
  }, [fcid])

  // 예약하기 클릭
  const onReservationClick = (params) => {
    console.log(params)
    const { tcd, hour, classname, tname, classmemo } = params;
    Swal.fire({
      html: `
      <div style='display: flex; flex-direction: column; align-items: center; justify-content: center;'>
      <div style='text-align: left; width: 80%;'>${moment(sdate).format('YYYY년 MM월 DD일')} ${hour.slice(0, 2)}시 ${moment(sdate).format('dddd')}</div>
      <div style='text-align: left; width: 80%;'>${classname} - ${tname}</div>
      <div style='text-align: left; width: 80%;'>${classmemo}</div>
      </div>`,
      title: '예약하시겠습니까?',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: '쿠폰선택',
      cancelButtonText: '취소'
    })
      .then(async (result) => {
        if(result.isConfirmed) {
          // clickOpenCoupon(tcd, hour, classname, tname, classmemo);
          setOpenCoupon(true)
          const { tcd, hour, classname, tname, classmemo } = params;
        }
        // if (result.isConfirmed) {
        //   let result = await axios.post(configState.api + "/gympass/reservation_add", {
        //     token: token,
        //     mcd: login.mcd,
        //     level: login.level,
        //     cid: configState.cid,
        //     tcd: tcd,
        //     hour: hour,
        //     sdate: sdate,
        //     tcid: fcid,
        //   });
        //   if (result.data.success === 1) {
        //     Swal.fire('예약 되었습니다.')
        //       .then(() => {
        //         load_data();
        //       })
        //       .catch(e => Swal.fire(e));
        //   } else {
        //     Swal.fire('ERROR', result.data.msg);
        //   }
        // }
      })
      .catch((e) => Swal.fire(e));
  }

  const onLoginClick = () => {
    Swal.fire({
      title: "로그인 하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          setOpenLogin(true);
        }
      })
      .catch((e) => Swal.fire(e));
  }

  return (
    <Grid container direction="column">
      <Dialog
        fullScreen
        open={openCoupon}
        // onClick={clickOpenCoupon}
        onClose={() => setOpenCoupon(false)}
        >
        <Box
          sx={{
            width: '90%',
            textAlign: 'left',
            padding: '30px 0 10px 10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}>
          <img src='/img/back_button_black.png' onClick={() => setOpenCoupon(false)} />
          <Box
            sx={{
              margin: '16px 0 0 10px',
              fontSize: '25px',
              fontWeight: 'bold'
            }}
            >
            {/* 쿠폰 선택 */}
          </Box>
        </Box>
        <CouponSelect />
      </Dialog>
      <Dialog
        fullScreen
        open={openLogin}
        TransitionComponent={Transition}
        onClose={clickCloseLogin}
      >
        <Box
          sx={{
            width: '90%',
            textAlign: 'left',
            padding: '30px 0 10px 10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}>
          <img src='/img/back_button_black.png' onClick={clickCloseLogin} />
          <Box
            sx={{
              margin: '16px 0 0 10px',
              fontSize: '25px',
              fontWeight: 'bold'
            }}>
            로그인
          </Box>
        </Box>
        <Login onCloseLogin={clickCloseLogin}></Login>
      </Dialog>

      <Box
        style={{
          // position: "fixed",
          position: 'absolute',
          top: 0,
          width: "100%",
          height: '260px',
          overflow: 'hidden',
          zIndex: 10,
        }}
      >
        <img src='/img/book_header_noword.jpg' style={{ width: '100%' }} />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',

            // fontWeight: 'bold'
          }}>
          <Box
            sx={{
              fontSize: '46px',
              fontFamily: 'BebasNeue',
              color: 'white',
            }}>
            RESERVATION
          </Box>
          <Box
            sx={{
              fontSize: '18px',
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              marginTop: '-6px'
            }}>
            수업예약
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: "260px" }}></Box>
      <Grid container flex="1" justifyContent="center" alignItems="center" sx={{ width: '100%', height: "100%" }}>
        {loaded === true && (fcid === undefined || fcid === '') && (
          <Grid sx={{ zIndex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              // height='100%'
              sx={{ minHeight: 200 }}
              widht='100%'>
              <Box
                sx={{
                  width: '85%',
                  // marginLeft: '60px',
                  marginTop: '20px',
                  // fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                즐겨 찾는 매장 선택
              </Box>
              <Box
                width='85%'
                fontSize='14px'>
                즐겨 찾는 매장을 선택하세요.
              </Box>
              <Box
                width='85%'
                fontSize='14px'>
                (예약화면에서 언제든 변경 가능합니다.)
              </Box>
              <List>
                <ListItem>
                  <ListItemButton
                    // onClick={() => setTcid('CID00000009')}
                    onClick={
                      () => setFcid('CID00000009')
                    }
                  >
                    <ListItemIcon
                      sx={{
                        width: '30%',
                      }}>
                      <img src="/img/center001.jpeg" width='100%' style={{ borderRadius: '8px' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary='정관점'
                      secondary='부산광역시 기장군 정관읍 정관4로 42, 풍산빌딩 3층'
                      sx={{
                        wdith: '100%',
                        marginLeft: '10px'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => setFcid('CT17X10111035.huwy5')}>
                    <ListItemIcon
                      sx={{
                        width: '30%'
                      }}>
                      <img src="/img/G_center001.jpeg" width='100%' style={{ borderRadius: '8px' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary='고현점'
                      secondary='경상남도 거제시 옥포대첩로 38, 9층 (유리빌딩)'
                      sx={{
                        wdith: '100%',
                        marginLeft: '10px'
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          </Grid>
        )}
          {loaded === true && (fcid != undefined && fcid != '') && (
            <>
            <Grid sx={{ zIndex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {/* <Box sx={{ height: "50px" }}></Box> */}
              <Box
                sx={{
                  display: 'flex',
                  width: '90%',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                <Box
                  sx={{
                    fontSize: '14px',
                    // width: '90%',
                    fontWeight: 'bold',
                    mt: 2
                  }}>
                  예약 진행 순서
                </Box>

              </Box>

              <Box
                sx={{
                  fontSize: '14px',
                  width: '90%',
                }}>
                센터 클릭 후 원하는 날짜를 선택하시면 수업 목록이 나옵니다.
                <br></br>
                로그인 후 클래스를 선택하시면 바로 예약 가능합니다.
              </Box>

              <Box
                sx={{
                  width: '90%',
                  textAlign: 'right',
                  mt: 1
                }}
              >
                <ThemeProvider theme={inputTheme}>
                  <FormControl>
                    <InputLabel>센터 선택</InputLabel>

                    <Select
                      value={fcid}
                      onChange={(e) => {
                        setFcid(e.target.value);
                      }}
                      // defaultValue={tcid}
                      size='small'
                      sx={{
                        width: '90px',
                        height: '25px',
                        // marginTop: '16px',
                        fontSize: '14px'
                      }}>
                      <MenuItem value='CID00000009'>
                        정관점
                      </MenuItem>
                      <MenuItem value='CT17X10111035.huwy5'>
                        고현점
                      </MenuItem>
                    </Select>
                  </FormControl>
                </ThemeProvider>
              </Box>

              <ThemeProvider theme={theme}>
                {/* localiszationprovider에서 locale로 설정을 해주면 해당 국가에 맞게 날짜형식 변경 */}
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                  <StaticDatePicker
                    sx={{
                      '&.MuiPickerStaticWrapper': { width: "100%", },
                      ['&&.MuiTypography-caption']: {
                        color: "black",
                      }
                    }}
                    autoOk
                    views={["year", "month", "day"]}
                    displayStaticWrapperAs="desktop"
                    // shouldDisableDate={disableDate}
                    value={date}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={onChangeDate}
                    renderInput={(params) => <TextField {...params} />}
                    //날짜에 badge로 표시하기
                    renderDay={(day, value, DayComponentProps) => {
                      var d = moment(day).format("DD");
                      const isSelected =
                        !DayComponentProps.outsideCurrentMonth &&
                        highlightedDays.indexOf(day.getDate()) > 0;
                      return (
                        <Grid key={d}>
                          <PickersDay
                            {...DayComponentProps}

                            // 선택된 날짜 #0092a2 색으로 출력
                            sx={{
                              // fontWeight: "bold",
                              fontSize: "15px",
                              ["&&.Mui-selected"]: { background: "#0092a2", color: "white" },
                              borderRadius: "100%",
                              padding: "0 2px",
                              // border: "1px solid gray",
                              "&.MuiPickersDay-today": { border: "1px solid #0092a2", color: "#0092a2" },
                              width: "36px",
                              height: "36px",
                              isSelected: { background: "black", color: "white" }
                            }}
                          />
                        </Grid>
                      );
                    }}
                  />
                </LocalizationProvider>
              </ThemeProvider>
            </Grid>
            {/* 일정 */}

            <Grid className="table" style={{ width: "100%", marginBottom: "5px" }}>
              <Box
                className="tabletitle"
                style={{
                  background: "#c7c7c7",
                  textAlign: "center",
                  color: "#414042",
                  padding: "5px",
                }}
              >
                {moment(sdate).format("YYYY년 MM월 DD일")}
              </Box>
              {/* {lectures.filter(lecture => lecture.day === moment(date).format('YYYY-MM-DD'))} */}

              {
                login.mcd === undefined || login.mcd === "" && lectures.length > 0 ?
                  <>
                    {lectures.map((item, index) => {
                      const is_applicate = item.count < item.max_count; // 예약가능
                      return (
                        <>
                          <Grid
                            key={index}
                            container
                            direction="row"
                            style={{
                              borderBottom: "solid 0.5px #c7c7c7",
                              padding: '5px 0'
                              // borderTop: "none",
                            }}
                            onClick={() => onLoginClick()}
                          >
                            <Grid
                              className="time"
                              container
                              alignItems="center"
                              justifyContent="center"
                              item
                              xs={3}
                              style={{
                                borderRight: "dotted 0.5px gray",
                                fontSize: "13px",
                              }}
                            >
                              {item.shour}
                            </Grid>
                            <Grid
                              className="discription"
                              container
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              style={{
                                padding: "5px",
                              }}
                              item
                              xs
                            >
                              <Grid justifyContent="center">
                                <Box
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.class_name}
                                </Box>
                                <Box
                                  sx={{
                                    fontSize: "13px",
                                  }}
                                >
                                  {item.tname}
                                  <br />

                                </Box>
                              </Grid>
                              {is_applicate ?
                                <Grid className="btnres"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}>
                                  <Box
                                    sx={{
                                      fontSize: '14px'
                                    }}>
                                  </Box>
                                  <img src='/img/back_button_black.png' style={{ transform: 'scaleX(-1)' }} />
                                  {/* <Button hour="09:00" tcd="5555" variant='contained' onClick={() => onReservationClick({ tcd: item.tcd, hour: item.shour })}>
                          예약하기
                        </Button> */}
                                </Grid>
                                :
                                <>
                                  <Button
                                    variant="contained"
                                    disabled
                                  >
                                    예약마감
                                  </Button>
                                </>}
                            </Grid>
                          </Grid>
                        </>
                      )
                    })}
                    <Box sx={{ height: '80px' }}></Box>
                  </>
                  :
                  // 로그인
                  lectures.map((item, index) => {
                    console.log(item)
                    let is_applicate = false; // 예약가능 (당일가능)
                    if (item.count < item.max_count) {
                      if (moment(sdate + ' ' + item.shour).format("YYYY-MM-DD HH") <= moment().format("YYYY-MM-DD HH")) {
                      } else {
                        is_applicate = true;
                      }
                    }

                    return (
                      <Grid
                        key={index}
                        container
                        direction="row"
                        style={{
                          borderBottom: "solid 0.5px #c7c7c7",
                          padding: '5px 0'
                          // borderTop: "none",
                        }}
                        onClick={() => {
                          if (is_applicate) {
                            onReservationClick({ tcd: item.tcd, hour: item.shour, classname: item.class_name, tname: item.tname, classmemo: item.class_memo });
                          }
                        }}
                      >
                        <Grid
                          className="time"
                          container
                          alignItems="center"
                          justifyContent="center"
                          item
                          xs={3}
                          style={{
                            borderRight: "dotted 0.5px gray",
                            fontSize: "13px",
                          }}
                        >
                          {item.shour}
                        </Grid>
                        <Grid
                          className="discription"
                          container
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          style={{
                            padding: "5px",
                          }}
                          item
                          xs
                        >
                          <Grid justifyContent="center">
                            <Box
                              sx={{
                                fontWeight: "bold",
                              }}
                            >
                              {item.class_name}
                            </Box>
                            <Box
                              sx={{
                                fontSize: "13px",
                              }}
                            >
                              {item.tname}
                              <br />

                            </Box>
                          </Grid>
                          {is_applicate ?
                            <Grid className="btnres"
                              sx={{
                                display: 'flex',
                                alignItems: 'center'
                              }}>
                              <Box
                                sx={{
                                  fontSize: '14px'
                                }}>
                                {item.count} / {item.max_count}
                              </Box>
                              <img src='/img/back_button_black.png' style={{ transform: 'scaleX(-1)' }} />
                              {/* <Button hour="09:00" tcd="5555" variant='contained' onClick={() => onReservationClick({ tcd: item.tcd, hour: item.shour })}>
                          예약하기
                        </Button> */}

                            </Grid>
                            :
                            <>
                              {/* <Button variant='contained' disabled>마감</Button> */}
                            </>
                          }
                        </Grid>
                      </Grid>
                    )
                  })
              }



              {/* 데이타 없음 */}
              {lectures.length === 0 &&

                <Box display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ minHeight: 150 }}
                >
                  수업이 없습니다
                </Box>}

              <Box sx={{ height: "100px" }}></Box>
            </Grid>
          </>
          )}
          
        

      </Grid>
      {/* <div css={ css `border:1px solid #cccccc;`}>xxxxxx</div> */}
      <BottomButton login={login} loaded={loaded} />
      <BottomMenu active="book" sx={{ zIndex: 10 }}></BottomMenu>
    </Grid>
  );
}

export default Book;